import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      component: () => import('@/views/404.vue')
    },
    {
      path: '/topay',
      component: () => import('@/views/pay/index.vue')
    },
    {
      path: '/paycallback',
      component: () => import('@/views/pay/paycallback.vue')
    },
    {
      path: '/pay/query/pc',
      component: () => import('@/views/pay/query/pc/query.vue')
    },
    {
      path: '/pay/query/h5',
      component: () => import('@/views/pay/query/h5/query.vue')
    },
    {
      path: '/pay/query/h5/list',
      component: () => import('@/views/pay/query/h5/list.vue')
    },
    {
      path: '/pay/default',
      component: () => import('@/views/pay/default.vue')
    },
    {
      path: '/transfer',
      component: () => import('@/views/pay/transfer/index.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js